const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 12C2 6.47715 6.47715 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM3.5 12C3.5 16.6944 7.30558 20.5 12 20.5V20.51C16.6938 20.499 20.4945 16.6938 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12Z",
  fill: "#0C2846"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.87 6.85C14.5155 6.66015 14.0744 6.78367 13.87 7.13L11.87 10.77L10.29 9.23C10.1337 8.96548 9.83182 8.82306 9.52825 8.87061C9.22469 8.91816 8.98084 9.14606 8.91289 9.44571C8.84494 9.74537 8.96664 10.0562 9.22 10.23L11.45 12.48C11.5882 12.6253 11.7795 12.7083 11.98 12.71H12.09C12.3228 12.6766 12.5264 12.5359 12.64 12.33L15.16 7.83C15.3353 7.47783 15.2087 7.05006 14.87 6.85Z",
  fill: "#0C2846"
});

const SvgEquationCategory0 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationCategory0, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-category-0.87c72c26.svg";
export { ForwardRef as ReactComponent };